import React, { useState } from "react"; 
import moment from "moment";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

import NumberFormat from "react-number-format";

import { setBooking, getCSDetail } from "../../../../actions/csDetailAct";

import { commonErr } from "../../../common/errors";
import { LoadingInline } from "../../../common/loading";
import { MessagePage } from "../../../common/messagebox";

import { TooltipCustom } from "../../../components/tooltip";


import {
	formatPrice,
	isEmptyObj,
	convertSecondToTime,
	formatTitleInUrl
} from "../../../common/common";


import { IcCSStock } from "../../../common/svg"
import car_photo from "../../../../static/images/upload/car_1.png";

class PriceTableBox extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			relatedList: [],
			isMCalendar: false,
			swiperCar: null 
		};

	}
    componentDidMount() {
		const { skuGroupId } = this.props;
		const filter = this.props.csFinding.filter;

		let ex = {
			skuGroupId: skuGroupId, 
			st: filter.startDate.valueOf(),
			et: filter.endDate.valueOf(),
			// deliveryId: filter.deliveryId,
			vw: 'cd'
		}


		if (filter.lat && filter.lng) {

			ex.lat = filter.lat
			ex.lon = filter.lng

            // this.setBooking(ex)
			this.getCar(ex)
		} else if (filter.address && filter.address !== "") {
			searchInHouse(filter.address).then((response) => {
				if (response.data.error >= commonErr.SUCCESS && response.data.data && response.data.data.locations.length > 0) {
					const loc = response.data.data.locations[0];
					let latLng = { lat: loc.lat, lng: loc.lon };

					ex.lat = latLng.lat
					ex.lon = latLng.lng

                    // this.setBooking(ex)
					this.getCar(ex)
				}
			});
		} else {
            // this.setBooking(ex)
			this.getCar(ex)
		}
	}

	componentDidUpdate(props) {
		const filter = props.csFinding.filter;
		const skuGroupId = props.skuGroupId;

		if (
			skuGroupId !== this.props.skuGroupId ||
			filter.address !== this.props.csFinding.filter.address ||
			filter.lat !== this.props.csFinding.filter.lat ||
			filter.lng !== this.props.csFinding.filter.lng
		) {

			let ex = {
				skuGroupId: this.props.skuGroupId, 
				st: filter.startDate.valueOf(),
				et: filter.endDate.valueOf(),
				// deliveryId: filter.deliveryId,
				vw: 'cd'
			}

			if (filter.lat && filter.lng) {
			
				ex.lat = filter.lat
				ex.lon = filter.lng

                // this.setBooking(ex)
				this.getCar(ex)
			} else if (filter && filter.address !== "") {
				searchInHouse(filter.address).then((response) => {
					if (
						response.data.error >= commonErr.SUCCESS &&
						response.data.data &&
						response.data.data.locations.length > 0
					) {
						const loc = response.data.data.locations[0];
						let latLng = { lat: loc.lat, lng: loc.lon };

						ex.lat = latLng.lat
						ex.lon = latLng.lng

                        // this.setBooking(ex)
						this.getCar(ex)
					}

				});
			} else {
			    // this.setBooking(ex)
				this.getCar(ex)
			}

		}
	}

	getCar = (ex) => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.props.dispatch(getCSDetail(ex)).then((resp) => {
			if (resp.action.payload.data.error === commonErr.SUCCESS) {
				this.setState({
					err: commonErr.SUCCESS,
				});
			}
		});
	};

    setBooking = (f) => {
		this.props.dispatch(setBooking(f));
	};

	totalDiscount = (priceSummary) => {
		const totalDiscountPercent = priceSummary && priceSummary.specialDiscount > 0 ? parseInt(priceSummary.specialDiscount/priceSummary.priceOrigin*100) : 0
		return totalDiscountPercent
	}

	setSwiperCar = (swiper) => {
		this.setState({
			swiperCar: swiper
		})
	}

	tooltRentTitle = () => {
		return (
			<>
				Giá cơ bản
			</>
		);
	}
	tooltRent = () => {
		return (
			<>
				Giá cơ bản là giá tính theo 30 ngày thuê xe & chưa bao gồm khuyến mãi (nếu có)
			</>
		);
	}

    render () {
		let content; 
		const { err } = this.state; 

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
			content = <LoadingInline />
		} else if (err === commonErr.SUCCESS && this.props.csDetail.detail) {
		
	
			const { info, profiles, relatedCars, cars } = this.props.csDetail.detail;
			const groupYear = info.years[0]
			const daysAvailableInSeconds = groupYear && groupYear.daysAvailableInSeconds
			const dayAvailable = parseInt(daysAvailableInSeconds / 3600 / 24)
			

			content = (
				<div className="modal-confirm-body">
				<div className="item-box-inner"> 
					<div className="item-img">
				
						<>
							<div className="img-inner fix-img">
								<img loading="lazy" src={info.thumbUrl ? info.thumbUrl : car_photo} />
							</div>
							{/* <Swiper
								className="swiper-img-car"
								slidesPerView={1}
								modules={[Navigation, Pagination]}
						
								navigation={{
									nextEl: ".img-car-next",
									prevEl: ".img-car-prev",
								}}
								onSwiper={(swiper) => {
									this.setSwiperCar(swiper);
								}}
							>
								{info.photos.map((photo, i) => (
										<SwiperSlide key={i}>
											<div
												className="img-inner"
												onClick={(e) => {
											
												
												}}>
												<img loading="lazy" src={photo[0]} />
											</div>
										</SwiperSlide>
									))
								}
							
							</Swiper>
							<div className="swiper-button-prev img-car-prev" />
							<div className="swiper-button-next img-car-next" /> */}
						</>
								
					{/* ) : (
						<div
							className="img-inner"
							>
							<img loading="lazy" src={info.thumbUrl ? info.thumbUrl : car_photo} />
						</div>
					)} */}


					</div>
					<div className="item-info-dt">
					<div className="item-title">
						<h3>{info.name}</h3>
					</div>
					<div className="available">   
						<div className="available-text"> 
							<div className="wrap-svg"> 
								<IcCSStock />
							</div>
							<p className="fontWeight-5 font-12">{info.years[0]?.stock} xe có sẵn</p>
						</div>
						<div className="available-text"> 
							<p className="fontWeight-5 font-12">Xe sẵn sàng vào ngày {moment().add(dayAvailable, 'days').format("DD/MM/YYYY")}</p>
						</div>
					</div>
					<div className="price-table"> 
						<p className="title">Bảng giá tham khảo</p>
						<div className="price-place">
							<div className="price-inner"> 
								<p className="content-tb">Năm sx</p>
								<TooltipCustom clgTitle={'content-tb'} title={this.tooltRentTitle} desc={this.tooltRent} />
								{/* <p className="content-tb">Giá cơ bản</p> */}
								<p className="content-tb" />
								{info.years?.length > 0 && info.years[0].priceSummary?.map((price, i) => 
									i < 3 ? <p className="content-tb" key={i}>Gói {price.totalMonths}th</p> : null)
								}
							</div>
						
							{info?.years && info?.years.map((year, i) => <React.Fragment key={i.toString()}> 
								<div className="price-inner price-content"> 
								<p className="content-tb">{year.yearFrom}-{year.yearTo}</p>
						
								{year.priceSummary ? <div className="content-tb"> 
									<p className="price fontWeight-8 text-primary font-16">
										<NumberFormat
											value={formatPrice(year.priceSummary[0].priceOrigin)}
											displayType={"text"}
											thousandSeparator={","}
											suffix={"K"}
										/> 
									</p>
									{/* <span className="font-12 fontWeight-500">/th</span> */}
								</div>
									
								: "-"}

								<p className="content-tb line" />

								{year.priceSummary.map((price, i) => i < 3 ? <p className="content-tb dis">{this.totalDiscount(price) > 0 ? `-${this.totalDiscount(price)}%` : "-"}</p> : null)}

							</div>
							{i < (info.years.length - 1) ? <div className="line-page" /> : null}
							</React.Fragment>)}
						</div>
						<p className="note-text">Giá đã bao gồm VAT, phí bảo hiểm, giao nhận &amp; dịch vụ bảo dưỡng xe.</p>
					</div>
					<a className="btn btn-primary btn--m"  href={`/carsubscription/${formatTitleInUrl(info?.name)}/${info?.skuGroupId}`} target={"_blank"}>Xem chi tiết</a>
					</div>
				</div>
			</div>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy thông tin."} />;
		}

	return (<Modal show={this.props.show} onHide={this.props.hideModal} dialogClassName="modal-dialog modal-confirm list-car-wrapper">
		<Modal.Header closeButton={true} closeLabel={""}>
	
		</Modal.Header>
		<Modal.Body>
			{content}
		</Modal.Body>
	</Modal>)}
}

function mapState(state) {
	return {
		csFinding: state.csFinding,
		session: state.session,
		csDetail: state.csDetail
	};
}



PriceTableBox = connect(mapState)(PriceTableBox);


export default PriceTableBox

		{/* <p className="content-tb dis">-10%</p>
								<p className="content-tb dis">-10%</p> */}
								{/* {year.priceSummary ? <p className="content-tb">
									<NumberFormat
										value={formatPrice(year.priceSummary[1].priceSpecial)}
										displayType={"text"}
										thousandSeparator={" "}
										suffix={"K"}
									/></p> : "-"}
								{year.priceSummary ? <p className="content-tb">
									<NumberFormat
										value={formatPrice(year.priceSummary[2].priceSpecial)}
										displayType={"text"}
										thousandSeparator={" "}
										suffix={"K"}
									/> 
								</p> : "-"} */}